/* ─────────────────────────────────────────────────────────────────
   MLW Quiz Segment Router
   ─────────────────────────────────────────────────────────────────
   Maps the user's Q1 answer to one of three result segments:

     diagnosed   — "I'm diagnosed with hypothyroidism"
     undiagnosed — "I have symptoms but no diagnosis"
     hashimotos  — "I'm diagnosed with Hashimoto's"

   Contract
     answers[] — as returned by MLWQuiz.getAnswers(). The first
                 routing question's answer is an object shaped
                 { label, value, segment } (see assets/quiz-inputs.js
                 renderChoice — the `routing` flag triggers this
                 shape). Non-routing questions store a scalar or
                 object that the router ignores.

   Fallbacks
     If no routing answer is present — or its segment is not one of
     the three known slugs — we return the "diagnosed" segment as
     a safe default. MLW's result copy is ~90% identical across
     segments, so the fallback stays on-brand even if routing fails.

   API
     window.MLWQuizSegmentRouter.getSegment(answers)
       → { segment: "diagnosed"|"undiagnosed"|"hashimotos",
           segmentName: "Diagnosed"|"Undiagnosed"|"Hashimoto's" }

     window.MLWQuizSegmentRouter.SEGMENTS
       — constant map of slug → display name
   ───────────────────────────────────────────────────────────────── */

(function (window) {
  "use strict";

  var SEGMENTS = {
    diagnosed:   "Diagnosed",
    undiagnosed: "Undiagnosed",
    hashimotos:  "Hashimoto's"
  };

  var DEFAULT_SEGMENT = "diagnosed";

  function normalize(raw) {
    if (!raw) return null;
    var s = String(raw).toLowerCase().trim();
    /* Accept a handful of common variants the schema might throw
       at us (apostrophes, spaces, underscores) before giving up. */
    if (s === "hashimoto's" || s === "hashimoto" || s === "hashimotos") return "hashimotos";
    if (s === "diagnosed" || s === "hypothyroid" || s === "hypothyroidism") return "diagnosed";
    if (s === "undiagnosed" || s === "symptoms") return "undiagnosed";
    return Object.prototype.hasOwnProperty.call(SEGMENTS, s) ? s : null;
  }

  /* Walk the answers array in order and return the first routing
     answer we can resolve. The quiz engine uses index 0 for Q1 in
     every MLW template, but scanning is cheap and makes the router
     resilient to future question reordering. */
  function extractSegment(answers) {
    if (!Array.isArray(answers)) return null;
    for (var i = 0; i < answers.length; i++) {
      var a = answers[i];
      if (!a || typeof a !== "object") continue;
      /* assets/quiz-inputs.js renderChoice writes { label, value,
         segment } when the question is flagged routing. */
      var candidate = a.segment || a.value || a.label;
      var slug = normalize(candidate);
      if (slug) return slug;
    }
    return null;
  }

  function getSegment(answers) {
    var slug = extractSegment(answers) || DEFAULT_SEGMENT;
    return { segment: slug, segmentName: SEGMENTS[slug] };
  }

  window.MLWQuizSegmentRouter = {
    SEGMENTS: SEGMENTS,
    getSegment: getSegment,
  };
})(window);
